/**
 * 该文件为脚本自动生成文件，请勿随意修改。如需修改请联系 PMC
 * */

import { TdRadioProps, TdRadioGroupProps } from './type';

export const radioDefaultProps: TdRadioProps = {
  allowUncheck: false,
  defaultChecked: false,
  disabled: undefined,
  readonly: undefined,
  readOnly: undefined,
  value: undefined,
};

export const radioGroupDefaultProps: TdRadioGroupProps = {
  allowUncheck: false,
  disabled: undefined,
  readonly: undefined,
  readOnly: undefined,
  size: 'medium',
  variant: 'outline',
  theme: 'radio',
};
